// extracted by mini-css-extract-plugin
export default {"mfa_container":"Account_mfa_container__TFc8u"};